module.exports = __webpack_public_path__ + "static/media/42-iveco.faa22ded.jpg";